import { useApolloClient } from '@apollo/client';
import { usePackageContext } from '@openx/components-package/utils/context/PackageContext';
import type { PackageOperationData } from '@openx/types/package/PackageHookTypes';
import { usePackageArchive } from './usePackageArchive';

export const usePackageOperationActions = () => {
  const apolloClient = useApolloClient();

  const { usePackageClone } = usePackageContext();

  const { clonePackage } = usePackageClone();

  const { archivePackage } = usePackageArchive();

  const clonePackages = async (packages: PackageOperationData[]) => {
    await clonePackage({ packages });
    apolloClient.refetchQueries({ include: ['GetPackageList', 'GetOpenxCuratedPackages'] });
  };

  const deletePackages = async (packages: PackageOperationData[]) => {
    await archivePackage(packages);
    apolloClient.refetchQueries({ include: ['GetPackageList', 'GetOpenxCuratedPackages'] });
  };

  return { clonePackages, deletePackages };
};
